export const en = {
    'add-minus-word': 'Add to negative keywords'
};
